export const ACCESS_ROUTES = [
  '/auth'
];

/**
 * Logo único de la marca. Antes se elegía entre IT DRAFT y MIRU según el
 * hostname (`app.itdraft.mx` vs cualquier otro); ahora es el mismo en toda
 * la app, sin importar el dominio.
 */
export const LOGO_URL = 'https://itdraft.mx/logo-itdraft-color.svg?imwidth=256';

/**
 * Logo blanco para lienzos oscuros (header del admin). El de color es para
 * fondos claros; sobre el header oscuro iba en capsula blanca y se veia
 * como un parche.
 */
export const LOGO_URL_WHITE = 'https://itdraft.mx/logo-itdraft-white.svg';

export const UNPROTECTED_ROUTES = [
  '/document',
  '/auth'
];

export const APP_URLS = {
  LOGIN: '/',
  DASHBOARD: '/admin',
  HOME: '/admin/inicio',
  REPORTS: '/admin/reports',
  COMPANIES: '/admin/companies',
  ADMINS: '/admin/admins',
  TEMPLATES: '/admin/templates',
  TEMPLATE_EDITOR: '/admin/templates/editor',
  DOCUMENTS: '/admin/documents',
  DOCUMENT_CREATOR: '/admin/document/creator',
  DOCUMENT_CREATOR_V2: '/admin/document/creator-v2',
  /** Asistente unificado: elige origen (PDF o plantilla) y guía en 3 pasos. */
  DOCUMENT_WIZARD: '/admin/document/nuevo',
  CREATE_AI: '/admin/document/crear-con-ia',
  PROFILE: '/admin/profile',
  SUBSCRIPTION: '/admin/suscripcion',

  COMPLETE_DOCUMENT: '/document/complete-document',

};

/**
 * Etapa única del documento. La calcula el API (campo `stage`); aquí solo se
 * define cómo se pinta y en qué orden se listan los filtros.
 * Ver api-itdraft/src/utils/documentStage.js
 */
export const DOCUMENT_STAGES = [
  { key: 'borrador', label: 'BORRADOR', bg: '#E4E1D9', fg: '#35322C' },
  { key: 'vobo', label: 'EN VOBO', bg: '#DDF2EE', fg: '#084E45' },
  { key: 'firma', label: 'POR FIRMAR', bg: '#1E2B27', fg: '#F7F5EF' },
  { key: 'rechazado', label: 'RECHAZADO', bg: '#F7DEDA', fg: '#8C2A1C' },
  { key: 'listo', label: 'LISTO', bg: '#E4E1D9', fg: '#35322C' },
];

export const STATUS_DOCUMENT = [
  {
    slug: 'COMPLETADO',
    color: '#4CAF50',
  },
  {
    slug: 'PENDIENTE',
    color: '#FB8C00',
  }
];

export const STATUS_VOBO = [
  {
    slug: 'ACEPTADO',
    color: '#4CAF50',
  },
  {
    slug: 'PENDIENTE',
    color: '#FB8C00',
  },
  {
    slug: 'RECHAZADO',
    color: 'red',
  }
];
